export default __webpack_public_path__ + "ReachEveryReader.png";